import { render } from "./TypePage.vue?vue&type=template&id=21bd92cb"
import script from "./TypePage.vue?vue&type=script&setup=true&lang=js"
export * from "./TypePage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Playbooks/Admin/TypePage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21bd92cb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21bd92cb', __exports__)) {
    api.reload('21bd92cb', __exports__)
  }
  
  module.hot.accept("./TypePage.vue?vue&type=template&id=21bd92cb", () => {
    api.rerender('21bd92cb', render)
  })

}


export default __exports__